import http from "@/libs/http"
import type { AuthResponse } from "@/types/common"

export type AuthPhoneStatus = {
  exists: boolean | null
  termsAccepted: boolean | null
  messagesAccepted: boolean | null
}

export const requiresAuthConsent = (status: AuthPhoneStatus) =>
  status.exists !== true || status.termsAccepted !== true || status.messagesAccepted !== true

type CheckPhoneResponse = {
  exists?: boolean
  terms_accepted?: boolean
  messages_accepted?: boolean
}

export const checkAuthPhone = async (phone: string): Promise<AuthPhoneStatus> => {
  const { data } = await http.post<CheckPhoneResponse>("/api/auth/check-phone", { phone })

  return {
    exists: typeof data?.exists === "boolean" ? data.exists : null,
    termsAccepted: typeof data?.terms_accepted === "boolean" ? data.terms_accepted : null,
    messagesAccepted: typeof data?.messages_accepted === "boolean" ? data.messages_accepted : null,
  }
}

export const requestAuthCode = async (phone: string) => {
  await http.post("/api/auth/request-code", { phone })
}

export const verifyAuthCode = async ({
  phone,
  code,
  termsAccepted,
  messagesAccepted,
}: {
  phone: string
  code: string
  termsAccepted: boolean
  messagesAccepted: boolean
}) => {
  const { data } = await http.post<AuthResponse>("/api/auth/verify-code", {
    phone,
    code,
    terms_accepted: termsAccepted,
    messages_accepted: messagesAccepted,
  })

  return data
}
